import { API_ENDPOINTS } from '../constants/endpoints';
import { get, post, put } from '../utils/api.utils';
import StorageService, { STORAGE_KEYS } from '../utils/storage.util';
import { UsageResponse } from '../types/usage';
import { decodeMetadataToken } from '../utils/token.utils';

class UsageService {
  public static async fetchUsage(
    months?: number,
    termStart?: number,
    termEnd?: number
  ): Promise<UsageResponse> {
    try {
      const accessToken = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      const metadata = decodeMetadataToken();
      const subscriptionId = metadata?.companies?.[0]?.subscription.id
      const customerId = metadata?.companies?.[0]?.id
    // const subscriptionId = 'usage-test-sub-1'
    // Build query parameters
    const params = new URLSearchParams();
    
    // Priority: Send calculated dates if available (frontend is source of truth)
    if (termStart !== undefined && termEnd !== undefined) {
      params.append('termStart', termStart.toString());
      params.append('termEnd', termEnd.toString());
      // Don't send months when we have dates - they're redundant
    } else if (months !== undefined && months !== null) {
      // Fallback: send months for backward compatibility
      params.append('months', months.toString());
    }
    
    const queryString = params.toString();
    const url = `${API_ENDPOINTS.USAGE.FETCH}${customerId}${queryString ? `?${queryString}` : ''}`;
      const response = await get<UsageResponse>(
        url,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
      
      return response;
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw new Error('Unauthorized. Please login again');
      }      
      throw new Error('An error occurred while updating profile. Please try again');
    }
  }
}

export default UsageService;